import { render } from "./CGridColumnGroup.vue?vue&type=template&id=7e25d9d0&scoped=true"
import script from "./CGridColumnGroup.vue?vue&type=script&lang=js"
export * from "./CGridColumnGroup.vue?vue&type=script&lang=js"

import "./CGridColumnGroup.vue?vue&type=style&index=0&id=7e25d9d0&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e25d9d0"]])

export default __exports__